import {useEffect, useState} from 'react'

// This experiment includes exactly 1024px. Keep the desktop breakpoints intact.
export const MOBILE_VIEWPORT_QUERY = '(max-width: 1024px)'

export function useMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_VIEWPORT_QUERY).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_VIEWPORT_QUERY)
    const update = () => setIsMobile(mediaQuery.matches)
    update()
    mediaQuery.addEventListener('change', update)
    return () => mediaQuery.removeEventListener('change', update)
  }, [])

  return isMobile
}
